module.exports = __webpack_public_path__ + "img/6img_page-0001.b2685ba9.jpg";